const productFinderEls = document.querySelectorAll('.product-finder');
const isLive = document.querySelector('.-live');

productFinderEls.forEach((productFinderEl) => {
    if (isLive) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('product-finder--visible');
                    observer.unobserve(entry.target);
                }
            });
        });
        setTimeout(() => {
            observer.observe(productFinderEl);
        }, 800);
    }

    const itemEls = productFinderEl.querySelectorAll('.product-finder__selection-item');
    const submitEl = productFinderEl.querySelector('.product-finder__selection-submit a');
    let link = undefined;

    const values = { roomType: undefined, impactSound: undefined, moistureResistance: undefined };

    if (submitEl) {
        link = submitEl.getAttribute('href');
        const params = new URLSearchParams();

        submitEl.addEventListener('click', (event) => {
            Object.keys(values).forEach((key) => {
                const checkedOptionEls = productFinderEl.querySelectorAll(
                    `.product-finder__selection-item-select-option input[name="${key}"]:checked`
                );
                const combinedValues = [...checkedOptionEls].map((checkedOptionEl) => checkedOptionEl.value).join('_');

                if (checkedOptionEls.length > 0) {
                    params.set(key, combinedValues);
                }
            });

            if (link) {
                event.preventDefault();
                window.location.href = `${link}?${params.toString()}`;
            }
        });
    }

    itemEls.forEach((item) => {
        const optionEls = item.querySelectorAll('.product-finder__selection-item-select-option input');

        item.addEventListener('click', () => {
            item.classList.toggle('product-finder__selection-item--open');
        });

        optionEls.forEach((optionEl) => {
            optionEl.addEventListener('click', () => {
                const wasChecked = optionEl.dataset.wasChecked === 'true';

                optionEls.forEach((element) => {
                    element.checked = false;
                    element.dataset.wasChecked = false;
                });

                if (wasChecked) {
                    optionEl.checked = false;
                    optionEl.dataset.wasChecked = false;
                } else {
                    optionEl.checked = true;
                    optionEl.dataset.wasChecked = true;
                }
            });

            optionEl.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    const wasChecked = optionEl.dataset.wasChecked === 'true';

                    optionEls.forEach((element) => {
                        element.checked = false;
                        element.dataset.wasChecked = false;
                    });

                    if (wasChecked) {
                        optionEl.checked = false;
                        optionEl.dataset.wasChecked = false;
                    } else {
                        optionEl.checked = true;
                        optionEl.dataset.wasChecked = true;
                    }

                    optionEl.focus();
                }
            });
        });
    });
});
